import http from '@/api/http'

const REQUEST_URL = '/message_list/'

export default {
  /**
   * 未読メッセージがあるかユーザを指定して調べる
   */
  getUnreadCountMessage(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'get_unread',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 未読メッセージがあるか調べる
   */
  checkHasUnreadMessage(params?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'get_all_unread',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 選択したユーザとの全てのメッセージを既読に
   */
  alreadyReadSelectedUsers(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'already_read',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 全ての未読メッセージを既読に
   */
  allAlreadyReadSelectedUsers(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'all_already_read',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 選択したユーザとの全てのメッセージを削除
   */
  removeSelected(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'remove_selected',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 選択したユーザとの全てのメッセージを既読に
   */
  allDelete(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post(REQUEST_URL, {
          page: 'all_delete',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
